import React, { useMemo } from 'react';

import backgroundImg1 from '../../../../../../assets/2025/topic1000/background-6.png';
import computerImg from '../../../../../../assets/2025/topic1000/computer.png';
import computerMobileImg from '../../../../../../assets/2025/topic1000/computer-mobile.png';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import { useParams } from 'react-router-dom';
import { CTitle, WTitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
  });

  const startPlay = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    next += 1;
    setState({ play: next, isPlayed: true });
    updateComponentState(p_course, p_topic, ID, '2025-topic1000-section1-1');
    if (next <= 6) {
      setTimeout(() => startPlay(next), 1000);
    }
  };
  return (
    <div className="topic-section-1">
      <div className="definition-container">
        <WTitle title={paragraphsSettings?.title}></WTitle>
        <div className="definition-list">
          {paragraphsSettings?.l1?.map((item: { desc: string }) => (
            <div key={item.desc}>{item.desc}</div>
          ))}
        </div>
        <div className="img-container">
          <img src={backgroundImg1} alt="" />
        </div>
      </div>

      <div className="social-activity-container">
        <div className="subtitle-box">
          <CTitle title={paragraphsSettings?.l2}></CTitle>
        </div>

        <div
          className="sub-description"
          dangerouslySetInnerHTML={{
            __html: paragraphsSettings?.l3,
          }}
        />
        <div className="social-activity-content">
          <div className="content-list">
            {paragraphsSettings?.l4?.map(
              (item: { desc: string; name: string }) => (
                <div key={item.name} className="content-item">
                  <div className="item-title">{item.name}</div>
                  <div className="item-desc">{item.desc}</div>
                </div>
              )
            )}
          </div>

          <div className="computer-img-container">
            <img className="for-pc" src={computerImg} alt="" />
            <img className="for-mobile" src={computerMobileImg} alt="" />
          </div>
        </div>

        <div id="2025-topic1000-section1-1" className="result-container">
          <div className="result-title">
            <p>{paragraphsSettings?.l5}</p>
            <p>{paragraphsSettings?.l6}</p>
          </div>
          <div className="result-list" onClick={() => startPlay()}>
            {paragraphsSettings?.l7?.map(
              (item: { desc: string }, index: number) => (
                <div
                  key={item.desc}
                  className={`result-item ${
                    state.play > index ? 'fade-in' : ''
                  }`}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.desc,
                    }}
                  />
                </div>
              )
            )}
            <div className={`point-box ${state.play > 1 ? 'hide' : ''}`}>
              <img src={ArrowImg} alt="" />
            </div>
          </div>
        </div>

        <div className="example-container">
          <div className="example-title-box">
            <div className="example-title">{paragraphsSettings?.l8}</div>
          </div>
          <div className="example-content">
            <div className="left-box"></div>
            <div className="right-box">
              <div className="content-box">
                <p
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l10,
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l11,
                  }}
                />
              </div>
              <div className="content-box">
                <p
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l12,
                  }}
                />
                <p
                  className="hide-in-en"
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l13,
                  }}
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.l14,
                  }}
                />
              </div>
              <div className="source-box">
                <p>{paragraphsSettings?.l16}</p>
                <p>
                  <a
                    href={paragraphsSettings?.l17_1}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {paragraphsSettings?.l17}
                  </a>
                </p>
                <p>
                  <a
                    href={paragraphsSettings?.l18_1}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {paragraphsSettings?.l18}
                  </a>
                </p>
              </div>
            </div>
          </div>
          <div className="example-back"></div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
